import { ref } from "vue";
import { db } from "@/config/firebase";
import { collection, addDoc } from "firebase/firestore";

export function useSurveySave() {
  const saveStatus = ref({
    loading: false,
    error: null,
    success: false,
  });

  const saveSurveyData = async (surveyData, currentUser = null) => {
    // Test mode: save to localStorage only
    if (typeof window !== "undefined" && window.__SURVEY_TEST_MODE__) {
      try {
        const key = "surveyTestResponses";
        const existing = JSON.parse(localStorage.getItem(key) || "[]");
        existing.push({
          ...surveyData,
          savedAt: new Date().toISOString(),
          timestamp: new Date().toISOString(), // Add timestamp for retention tracking
        });
        localStorage.setItem(key, JSON.stringify(existing));
        saveStatus.value = {
          loading: false,
          error: null,
          success: true,
        };
      } catch (error) {
        saveStatus.value = {
          loading: false,
          error: error.message,
          success: false,
        };
      }
      return;
    }

    try {
      // Check if user is authenticated
      if (!currentUser) {
        saveStatus.value = {
          loading: false,
          error: "User must be authenticated to save survey data",
          success: false,
        };
        return;
      }

      // Set loading state
      saveStatus.value = {
        loading: true,
        error: null,
        success: false,
      };

      const surveyResponsesRef = collection(db, "surveyResponses");
      await addDoc(surveyResponsesRef, {
        ...surveyData,
        userId: currentUser.uid,
        userEmail: currentUser.email,
        submittedAt: new Date().toISOString(),
      });

      saveStatus.value = {
        loading: false,
        error: null,
        success: true,
      };
    } catch (error) {
      console.error("Error saving survey response:", error);
      saveStatus.value = {
        loading: false,
        error: error.message,
        success: false,
      };
    }
  };

  return {
    saveStatus,
    saveSurveyData,
  };
}
